import { paymentConstants, createPaymentPages } from "./types";

const initialState = { page:"orderDetail", addedPayment: false, smsSent: false, addingPayment: false, reloadPaymentList: false };

export default (state = initialState, action) => {
  switch (action.type) {
    case paymentConstants.ADD_PAYMENT_REQUEST:
      return {
        ...state,
        //...action.payload,
        addingPayment: true,
        addedPayment: false
      };
    case paymentConstants.ADD_PAYMENT_SMS:
      return {
        ...state,
        ...action.payload,
        addingPayment: false,
        smsSent: true,
        page:createPaymentPages.sms
      };
    case paymentConstants.ADD_PAYMENT_SUCCESS:
      return {
        ...state,
        ...action.payload,
        addingPayment: false,
        addedPayment: true,
        page:createPaymentPages.done
      };
    case paymentConstants.CHANGE_PAGE:
      return{
        ...state,
        ...action.payload
      } 
    case paymentConstants.PAYMENT_LIST_REQUEST:
      return {
        ...state,
        ...action.payload
      };
    case paymentConstants.PAYMENT_LIST_SUCCESS:
      return {
        ...state,
        ...action.payload,
        reloadPaymentList: false
      };
    case paymentConstants.CLEAR_SUCCESS_MESSAGE:
      return {
        ...state,
        addedPayment: false
      };
    case paymentConstants.CANCEL_PAYMENT_REQUEST:
      return {
        ...state,
        addedPayment: false
      };
    case paymentConstants.CANCEL_PAYMENT_SUCCESS:
      return {
        ...state,
        reloadPaymentList: true
      };
    case paymentConstants.PAYMENT_ERROR:
      return {
        ...state,
        ...action.payload
      };
    case paymentConstants.GET_ACTIVE_MEMBER_NUMBER:
      return {
        ...state,
        ...action.payload,
      };
    case paymentConstants.PAYMENT_SUMMARY_REQUEST:
        return {
          ...state,
          ...action.payload
        };
    case paymentConstants.PAYMENT_SUMMARY_SUCCESS:
        return {
          ...state,
          ...action.payload
        };
    case paymentConstants.GET_ACTIVE_MEMBER_NOLIST:
          return {
            ...state,
            ...action.payload,
          };
    default:
      return state;
  }
};
